import { render, staticRenderFns } from "./ExpansionActionsWrapperComponent.vue?vue&type=template&id=6bb4e3b0&scoped=true&"
import script from "./ExpansionActionsWrapperComponent.vue?vue&type=script&lang=js&"
export * from "./ExpansionActionsWrapperComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bb4e3b0",
  null
  
)

export default component.exports